import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";

import {
  ThemeProvider,
  LoadingBar,
  defaultTheme,
  StoreProvider,
  ControllerProvider,
} from "@searchspring/snap-preact-components";

import { Header } from "../Header/Header";
import { Results, NoResults } from "../Results/Results";
import { SkeletonLoader } from "./SkeletonLoader";

@observer
export class Content extends Component {
  render() {
    const store = this.props.tabs.active.controller.store;

    return (
      <ControllerProvider controller={this.props.tabs.active.controller}>
        <ThemeProvider theme={defaultTheme}>
          <StoreProvider store={store}>
            <div>
              <LoadingBar active={store.loading} />

              <Header tabs={this.props.tabs}/>

              {store.pagination.totalResults ? (
                <Results />
              ) : store.pagination.totalResults === 0 ? (
                  <NoResults />
              ) : (
                  <SkeletonLoader />
              )}

            </div>
          </StoreProvider>
        </ThemeProvider>
      </ControllerProvider>
    );
  }
}